import React, {useState, forwardRef, useImperativeHandle} from 'react';
import {useOnClickOutside} from '../../../../hooks/useOnClickOutside';
import ImgIconComp from '../../../../components/imgcomp';

type ListOption = {
    id: string,
    title: string
}

const noop = (e: any, name: string, list: any) => {}

const ListDropDown = forwardRef(({
    title = null,
    name = '',
    selectedValue = null,
    options = [],
    onSelect = noop,
    style = {},
    optionsComp = null
}: any, ref: any) => {
    const [openList, setOpenList] = useState<boolean>(false);
    const [listRef] = useOnClickOutside(() => {
        setOpenList(false);
    });

    const onSelectOption = (e: any, name: string, list: any) => {
        setOpenList(false);
        onSelect(e, name, list);
    }

    useImperativeHandle(ref, () => ({
        hideOpenList(value: any) {
            setOpenList(value);
        }
    }))

    return (
        <div className='flex-listbox' style={style}>
            <div className='flex-column'>
                <div className='flex-row listbox-dropdown' onClick={() => setOpenList(true)}>
                    <div className='listbox-title truncateText'>
                        {selectedValue}
                    </div>
                    <div className='listbox-arrow'>
                        <ImgIconComp id="cal_arrow_down" width="13" height="9" />
                    </div>
                </div>
                { (optionsComp != null) && openList && optionsComp()}
                { (optionsComp == null) && openList && (
                    <div ref={listRef} 
                        className='listbox-options-wrapper'>    
                        <div className='listbox-option-heading'>{title}</div>
                        {
                            options.map((list: ListOption, index: any) => (
                                <div key={`list_${index}`} 
                                    className='listbox-option truncateText'
                                    onClick={(e) => onSelectOption(e, name, list)}
                                    >
                                    {list.title}
                                </div>
                            ))
                        }
                    </div>
                )}
            </div>
        </div>
    )
});

export default ListDropDown;